import { Dialog, Toast } from 'vant'
import bus from '@/utils/bus'

import { isMobile, isVzanMiniAppPayment } from '@/utils/utils'
import { $orderApi } from '@/utils/http/modules/order/order.request'
import store from '@/store'

export const AppChannel = {
  register() {
    console.log('注册AppChannel，', isVzanMiniAppPayment())
    console.log('store,', store)
    const isAppToMiniPayGray =
      store.state.customConfig.openConfig &&
      store.state.customConfig.openConfig.includes('app_to_mini_pay')
    if (!isVzanMiniAppPayment() || !isAppToMiniPayGray) {
      return
    }
    window.__VzanAppChannelMessage = function (msgBody = {}) {
      try {
        const msg = typeof msgBody === 'string' ? JSON.parse(msgBody) : msgBody
        console.log('收到APP消息', msg)
        let { type, params = '{}' } = msg
        if (typeof params === 'string') {
          params = JSON.parse(params)
        }
        if (type === 'miniAppBackToApp') {
          afterMiniAppPaymentBackToApp(params.orderId)
        }
      } catch (error) {
        console.warn('vzanAppChannel onMessage 消息解析失败', error)
      }
    }
  },

  destroy() {
    window.VzanAppChannel = null
  },
}

/**
 * 检查订单支付状态
 * @param {number} orderId 订单id
 * */
function afterMiniAppPaymentBackToApp(orderId) {
  const checkOrderPaymentStatus = async () => {
    try {
      const res = await $orderApi.getPayState(+orderId)

      const toastMsg =
        res.code === 1
          ? '已完成支付，可在订单中心查看相订单详情'
          : '未完成支付，请重新进行支付'
      Toast(toastMsg)
      bus.$emit('finished-app-miniapp-payment', res.code === 1, orderId)
    } catch (error) {
      console.log(error)
    }
  }

  Dialog.confirm({
    title: '支付确认',
    message: '请在微信内完成支付，如您已支付完成，请点击【已完成支付】按钮',
    confirmButtonColor: '#006cff',
    cancelButtonText: '未支付',
    confirmButtonText: '已完成支付',
  })
    .then(checkOrderPaymentStatus)
    .catch(checkOrderPaymentStatus)
}
